module.exports = "/_next/static/resources/photo-2-cffd30a061bed6bac1de9f84edbbaf28.jpg";